// Source: app/scripts/controllers/company-stamp.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('CompanyStampController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  'Downloader',
  function ($scope, $modal, $filter, $location, toaster, crudService, Downloader) {

    $scope.afterInit = function (crudScope) {

      crudScope.downloadCompanyStampAttachment = function (companyStampId) {
        if(companyStampId) {
          Downloader.download('/data/rest/portal_attachments/get_company_stamp/' + companyStampId);
        }
      };

    }

  }
]);
